<script>
	import { T, getTranslate } from '@tolgee/svelte';
	import ButtonPrimary from '../Button/ButtonPrimary.svelte';
	import HorizontalDivider from '../Divider/HorizontalDivider.svelte';
	import background from '$lib/assets/images/background.png';

	const { t } = getTranslate();
</script>

<div
	class="flex flex-col gap-11 justify-center items-center md:justify-start md:items-start md:grid md:grid-cols-6"
>
	<div class="flex flex-col col-span-2 max-w-md px-11">
		<h3 class="py-2 md:mt-10">
			<T keyName="customer.profile.title" />
		</h3>
		<p class="py-2">
			<T keyName="customer.accountBenefit" />
		</p>
		<HorizontalDivider />
		<h3 class="py-2">
			<T keyName="loggedOut.title" />
		</h3>
		<p class="py-2">
			<T keyName="loggedOut.description" />
		</p>
		<ButtonPrimary class="mt-3" on:click text={$t('customerSession.outer.loginOrRegister')} />
	</div>
	<img class="mx-auto md:col-span-4" src={background} alt="Background" />
</div>
